// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"SectionMenuList_container__19vl2","placeholder":"SectionMenuList_placeholder__1DOi_"};